import {LOCATION_CHANGE} from 'connected-react-router';
import {defaultState} from '../state';
import * as CalculatorActions from '../../actions/CalculatorActions';
import * as UIActions from '../../actions/UIActions';
import * as WizardActions from '../../actions/WizardActions';
import * as WizardMXActions from '../../actions/WizardMXActions';
import {
    CalculatorApplicantSummaryDTO,
    ContinueHeaderSummaryDTO,
    DesiredVehicleApplicantSummaryDTO,
    FieldApplicantSummary
} from '../../types/mx/creditoReal/epics';
import {CalculatorStepViewFieldErrorState} from '../../types/mx/creditoReal/reducers';
import {isNumber} from '../../utils/ValidationUtils';
import {BankTarget} from '../../types/mx/types';
import {
    DEFAULT_DOWN_PAYMENT,
    DEFAULT_VEHICLE_PRICE,
    DEFAULT_YEAR,
    MAX_VEHICLE_PRICE
} from '../../constants/MotorcreditConstants';
import * as RoutesConstant from '../../constants/RoutesConstant';
import * as StateConstants from '../../constants/StateConstants';
import * as CookieUtils from '../../../common/utils/CookieUtils';
import * as LoginActions from '../../actions/LoginActions';
import * as UTMActions from '../../actions/UTMActions';
import * as ValidationActions from '../../actions/ValidationActions';
import {EMPTY_CATALOG} from '../../constants/GlobalConstants';
import * as CatalogActions from '../../actions/CatalogActions';
import {Catalog} from '../../../common/types/common';

const calculator = (state = defaultState.turboCash.calculator, action) => {

    switch (action.type) {
        case UTMActions.SET_VEHICLE_UTM_VALUES_ON_SIMULATOR.name: {
            const price: number = !!action.price && isNumber(action.price) ? parseFloat(action.price) : 0;
            const downPayment: number = !!action.downPayment && isNumber(action.downPayment) ?
                parseFloat(action.downPayment) : 0;
            return {
                ...state,
                queryStringPrice: price,
                queryStringDownPayment: downPayment,
                hasInsurance: action.hasInsurance,
                failInsurance: false
            };
        }
        case ValidationActions.GOT_PRICE_AND_DOWN_PAYMENT_ACTION.name:
            const priceSelected: number = state.queryStringPrice >= action.minAllowVehiclePrice &&
            state.queryStringPrice <= MAX_VEHICLE_PRICE ? state.queryStringPrice :
                DEFAULT_VEHICLE_PRICE;
            const minDP: number = Math.ceil(priceSelected * action.minDownPayment);
            const maxDP: number = Math.trunc(priceSelected * action.maxDownPayment);
            const dPSelected: number = state.queryStringDownPayment >= minDP && state.queryStringDownPayment <= maxDP ?
                state.queryStringDownPayment : minDP > DEFAULT_DOWN_PAYMENT ? minDP : DEFAULT_DOWN_PAYMENT;

            return {
                ...state,
                price: priceSelected,
                downPayment: dPSelected,
                queryStringPrice: 0,
                queryStringDownPayment: 0
            };
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            CookieUtils.deleteCookie(StateConstants.PRICE);
            CookieUtils.deleteCookie(StateConstants.DOWN_PAYMENT);
            CookieUtils.deleteCookie(StateConstants.HAS_INSURANCE);
            return {
                ...state,
                bank: BankTarget.CREDITO_REAL,
                quotas: [],
                monthlyPayment: {},
                months: 0,
                price: DEFAULT_VEHICLE_PRICE,
                downPayment: DEFAULT_DOWN_PAYMENT,
                hasInsurance: true,
                failInsurance: false,
                provinceSelected: EMPTY_CATALOG,
                modelSelected: EMPTY_CATALOG,
                versionSelected: EMPTY_CATALOG,
                brandSelected: EMPTY_CATALOG,
            };
        case WizardMXActions.APPLIES_TO_TURBO_CASH_MX_ACTION.name: {
            const price: number = parseInt(state.price, 10);
            const downPayment: number = parseInt(state.downPayment, 10);
            const minDownPayment: number = Math.ceil((action.minDownPayment * price));
            const maxDownPayment: number = Math.trunc((action.maxDownPayment * price));
            return {
                ...state,
                downPayment: downPayment >= minDownPayment && downPayment <= maxDownPayment ?
                    downPayment : minDownPayment,
                bank: BankTarget.TURBO_CASH
            };
        }
        case CalculatorActions.CHANGE_PRICE_ACTION.name:
            return {
                ...state,
                price: action.price
            };
        case ValidationActions.GOT_MIN_ALLOWED_VEHICLE_PRICE_ACTION.name:
            return {
                ...state,
                price: !!state.price ? state.price : DEFAULT_VEHICLE_PRICE
            };
        case CalculatorActions.CHANGE_DOWN_PAYMENT_AFTER_PRICE_ACTION.name:
        case CalculatorActions.CHANGE_DOWN_PAYMENT_ACTION.name:
            return {
                ...state,
                downPayment: action.downPayment
            };
        case ValidationActions.GOT_MIN_DOWN_PAYMENT_ACTION.name:
            const dp: number = !!action.minDownPayment && isNumber(action.minDownPayment) ?
                parseFloat(action.minDownPayment) : 0;
            const p: number = !!state.price && isNumber(state.price) ?
                parseFloat(state.price) : 0;

            return {
                ...state,
                downPayment: !!state.downPayment ? state.downPayment : DEFAULT_DOWN_PAYMENT
            };
        case CalculatorActions.CLEAN_QUOTAS_MX_ACTION.name:
            return {
                ...state,
                quotas: [],
                failInsurance: false
            };
        case CalculatorActions.GOT_QUOTAS_MX_ACTION.name:
            return {
                ...state,
                quotas: action.quotas.map(quota => ({
                    ...quota,
                    name: quota.displayName,
                    insuranceAmount: quota.insuranceAmount ? quota.insuranceAmount.displayValue : '',
                    financingAmount: quota.financingAmount ? quota.financingAmount.displayValue : '',
                    commissionAmount: quota.commissionAmount ? quota.commissionAmount.displayValue : '',
                    quotasDescription: quota.description,
                    monthlyPayments: quota.monthlyPayments && quota.monthlyPayments
                        .map(item => ({
                            id: item.term, value: item.term,
                            label: [`${item.term} pagos de`, item.monthlyQuota.displayValue]
                        })),
                })),
                failInsurance: action.failInsurance || false,
                hasInsurance: action.failInsurance ? false : state.hasInsurance
            };
        case CalculatorActions.MONTHLY_PAYMENT_SELECTED_ACTION.name:
            return {
                ...state,
                monthlyPayment: action.monthlyPayment
            };
        case CalculatorActions.HAS_INSURANCE_SELECTED_ACTION.name:
            return {
                ...state,
                hasInsurance: action.hasInsurance,
                failInsurance: false
            };
        case UIActions.CLEAN_STATE_ACTION.name:
            CookieUtils.deleteCookie(StateConstants.PRICE);
            CookieUtils.deleteCookie(StateConstants.DOWN_PAYMENT);
            CookieUtils.deleteCookie(StateConstants.HAS_INSURANCE);
            return defaultState.turboCash.calculator;
        case WizardActions.CHANGE_INCLUDE_INSURANCE_ACTION.name:
            return {
                ...state,
                hasInsurance: action.includeInsurance
            };
        case WizardMXActions.GOT_INSURANCE_ERROR_ACTION.name:
            return {
                ...state,
                hasInsurance: false
            };
        case WizardMXActions.SET_CALCULATOR_DATA_STATE_ACTION.name:
            const calculatorDataFS: FieldApplicantSummary<CalculatorApplicantSummaryDTO,
                CalculatorStepViewFieldErrorState> = action.fieldSummary;
            const calculatorSummary: CalculatorApplicantSummaryDTO = calculatorDataFS.data;
            return {
                ...state,
                downPayment: calculatorSummary.downPayment.value,
                monthlyPayment: {id: calculatorSummary.term, value: calculatorSummary.term, defaultChecked: true},
                hasInsurance: calculatorSummary.includeInsurance
            };
        case WizardMXActions.SET_DESIRED_VEHICLE_DATA_STATE_ACTION.name:
            const vehicleDataFS: FieldApplicantSummary<DesiredVehicleApplicantSummaryDTO,
                CalculatorStepViewFieldErrorState> = action.fieldSummary;
            const vehicleSummary: DesiredVehicleApplicantSummaryDTO = vehicleDataFS.data;
            return {
                ...state,
                price: vehicleSummary.price.value,
                brandSelected: vehicleSummary.brand,
                modelSelected: vehicleSummary.model,
                versionSelected: vehicleSummary.version,
                yearSelected: {
                    id: vehicleSummary.year.toString(),
                    value: vehicleSummary.year.toString()
                }
            };
        case LoginActions.SET_REDIRECT_URL_ACTION.name:
            CookieUtils.setCookie(StateConstants.PRICE, state.price, 1);
            CookieUtils.setCookie(StateConstants.DOWN_PAYMENT, state.downPayment, 1);
            CookieUtils.setCookie(StateConstants.HAS_INSURANCE, state.hasInsurance, 1);
            CookieUtils.setCookie(StateConstants.YEAR_SELECTED, state.yearSelected.id, 1);
            CookieUtils.setCookie(StateConstants.BRAND_SELECTED, state.brandSelected.id, 1);
            CookieUtils.setCookie(StateConstants.MODEL_SELECTED, state.modelSelected.id, 1);
            CookieUtils.setCookie(StateConstants.VERSION_SELECTED, state.versionSelected.payload, 1);
            return state;
        case LOCATION_CHANGE:
            if (RoutesConstant.CALCULATOR_PATH === action.payload.location.pathname.replace(/\/$/, '')) {
                const hasInsurance = CookieUtils.getCookie(StateConstants.HAS_INSURANCE) ?
                    JSON.parse(CookieUtils.getCookie(StateConstants.HAS_INSURANCE)) : state.hasInsurance;
                return {
                    ...state,
                    hasInsurance,
                    failInsurance: false
                };
            }
            return state;
        case CatalogActions.GOT_YEARS_ACTION.name:
            const yearSelected: Catalog = action.years.find(y => y.id === action.queryStringYear.toString()) ||
                action.years.find(y => y.id === DEFAULT_YEAR.id) || EMPTY_CATALOG;
            return {
                ...state,
                yearSelected
            };
        case CatalogActions.GOT_PROVINCES_ACTION.name:
            const provinceSelected: Catalog = action.province;
            return {
                ...state,
                provinceSelected: !!provinceSelected.id ? provinceSelected : state.provinceSelected
            };
        case CatalogActions.GOT_BRANDS_ACTION.name:
            const brandSelected: Catalog = action.brand;
            return {
                ...state,
                brandSelected
            };
        case CatalogActions.GOT_MODELS_ACTION.name:
            const modelSelected: Catalog = action.model;
            return {
                ...state,
                modelSelected: !!modelSelected.id ? modelSelected : state.modelSelected
            };
        case CatalogActions.GOT_VERSIONS_ACTION.name:
            const versionSelected: Catalog = action.version;
            return {
                ...state,
                versionSelected: !!versionSelected.id ? versionSelected : state.versionSelected
            };
        case CalculatorActions.YEAR_SELECTED_ACTION.name:
            return {
                ...state,
                yearSelected: action.year,
                brandSelected: EMPTY_CATALOG,
                modelSelected: EMPTY_CATALOG,
                versionSelected: EMPTY_CATALOG
            };
        case CalculatorActions.BRAND_SELECTED_ACTION.name:
            return {
                ...state,
                brandSelected: action.brand,
                modelSelected: EMPTY_CATALOG,
                versionSelected: EMPTY_CATALOG
            };
        case CalculatorActions.MODEL_SELECTED_ACTION.name:
            return {
                ...state,
                modelSelected: action.model,
                versionSelected: EMPTY_CATALOG
            };
        case CalculatorActions.VERSION_SELECTED_ACTION.name:
            return {
                ...state,
                versionSelected: action.version
            };
        case CalculatorActions.PROVINCE_SELECTED_ACTION.name:
            return {
                ...state,
                provinceSelected: action.province
            };
        case WizardMXActions.SET_CONTINUE_HEADER_DATA_STATE_ACTION.name:
            const continueHeaderFieldSummary: ContinueHeaderSummaryDTO = action.continueHeader;
            return {
                ...state,
                price: continueHeaderFieldSummary.vehiclePrice.value,
                downPayment: continueHeaderFieldSummary.financingDownPayment.value,
                monthlyPayment: {
                    ...state.monthlyPayment,
                    id: continueHeaderFieldSummary.financingTerm,
                    value: continueHeaderFieldSummary.financingTerm,
                    label: [
                        continueHeaderFieldSummary.financingTerm,
                        continueHeaderFieldSummary.monthlyPayment.displayValue
                    ]
                },
                quotas: [{
                    ...state.quotas,
                    financingAmount: continueHeaderFieldSummary.financingAmount.displayValue,
                    monthlyPayments: [{
                        ...state.monthlyPayment,
                        id: continueHeaderFieldSummary.financingTerm,
                        value: continueHeaderFieldSummary.financingTerm,
                        label: [
                            continueHeaderFieldSummary.financingTerm,
                            continueHeaderFieldSummary.monthlyPayment.displayValue
                        ]
                    }]
                }]
            };
        default:
            return state;
    }
};

export default calculator;